import React, { useEffect, useState } from "react";
import { Button, Row, Col, Select, Input, Form, Modal, notification, Checkbox } from "antd";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { componentStyles } from "./ProfileStyles";
import { getUser, updateUser } from "../../api/password";
import ClipLoader from "react-spinners/ClipLoader";
import { useLocation, useNavigate } from "react-router-dom";
import goBackButton from "../../assets/images/Go_Back.svg";
import moment from "moment";
import { Countries } from "../../constants/constants.js";
import { postRequest, putRequest } from "../../api/index.js";
import ProfileImageUpload from "./ProfileImageUpload.js";
import { getMedicalConsent, updateMedicalConsent } from "../../api/AdditionalServices.js";

var oldTrustedEmail;
var newTrustedEmail;
var checkTrustedEmailUpdate = false;
const Profile = () => {
  const { Option } = Select;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userId, setUserId] = useState(null);
  const [loader, setLoader] = useState(true);
  const [address, setAddress] = useState({ street: '', postal_code: '' });
  const [medicalConsent, setMedicalConsent] = useState(true);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    getUserInfo();
  }, []);

  const setAgeInProfile = (date) => {
    const dob = moment(date, "DD-MM-YYYY");
    const ageInYears = moment().diff(dob, "years");
    const ageInMonths = moment().diff(dob, "months") % 12;
    const age = `${ageInYears} Years & ${ageInMonths} Months`;
    return age;
  };

  const getUserInfo = async () => {
    try {
      const response = await getUser();
      if (response.id) {
        form.setFieldsValue({
          email: response.email,
          name: response.name,
          age: response.age,
          dob: response.dob,
          trustedEmail: response.truetedEmail,
          phone: response.phone,
          password: response.password,
          address_street: response.address_street,
          postal_code: response.postal_code,
          city: response.city,
          country: response.country === "Unknown" ? '' : response.country
        });
        oldTrustedEmail = response.truetedEmail;
        setAddress({
          street: response.address_street || '',
          postal_code: response.postal_code || ''
        });
        setUserId(response.id);
        try {
          const consent = await getMedicalConsent();
          setMedicalConsent(consent?.medicalConsent ?? true);
        } catch (e) {
          setMedicalConsent(true);
        }
        setLoader(false);
      }
      setLoader(false);
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const navigateToPreviousPage = () => {
    if (location.state && location.state.from) {
      navigate(location.state.from.pathname + location.state.from.search);
    } else {
      navigate("/landing-page");
    }
  };

  const handleBack = () => {
    navigateToPreviousPage();
  };
  const emailRules = [
    { required: true, message: "Please input your email!" },
    { type: "email", message: "The input is not a valid email!" },
  ];
  const handleSave = () => {
  form.validateFields()
    .then(async (values) => {
      try {
        const payload = {
          email: values.email,
          name: values.name,
          age: values.age,
          truetedEmail: values.trustedEmail,
          phone: values.phone,
          password: values.password,
          address_street: values.address_street,
          postal_code: values.postal_code,
          city: values.city,
          country: values.country,
        };

        const updateApiUser = await updateUser(userId, payload);
        await updateMedicalConsent(medicalConsent);

        if (updateApiUser) {
          notification.success({
            message: 'Edit Successful',
            description: 'Your personal information has been updated successfully.',
            placement: 'topRight',
          });
        }
      } catch (error) {
        
        // Show notification based on error status code
        const { status } = error.response || {};
        if (status === 400) {
          notification.error({
            message: 'Bad Request',
            description: 'Please check your input and try again.',
            placement: 'topRight',
          });
        } else if (status === 404) {
          notification.error({
            message: 'Not Found',
            description: 'User not found. Please refresh and try again.',
            placement: 'topRight',
          });
        } else if (status === 500) {
          notification.error({
            message: 'Server Error',
            description: 'An unexpected error occurred. Please try again later.',
            placement: 'topRight',
          });
        } else {
          notification.error({
            message: 'Error',
            description: error?.message ?  error?.message  : 'An error occurred while updating your information.',
            placement: 'topRight',
          });
        }
      }
    })
    .catch((errorInfo) => {
      console.error("Validation Failed:", errorInfo);
    });
};

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
  };

  return (
    <div
      style={{ minHeight: "100dvh", overflow: "hidden", background: "#fefcfe" }}
    >
      <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
        <Row
          justify={{
            xs: "space-around",
            md: "space-around",
            lg: "space-between",
          }}
          style={{ marginBottom: 20 }}
        >
          <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}
        </Row>
        <button onClick={handleBack} className="text-left pl-4 button-styling setBackButton">
          <img src={goBackButton} alt="Go Back Button" />
        </button>
        {loader ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <ClipLoader
              loading={loader}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <Form form={form}>
            <Row justify="center" style={{ padding: "25px" }}>
              <Col
                span={20}
                style={{
                  paddingLeft: "5%",
                }}
              >
               
              <Row className="mb-3" justify={"space-between"} align={"middle"}>
                <Col xs={24} sm={24} lg={4} md={4}  style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <ProfileImageUpload />
                </Col>
                <Col xs={24} sm={24} lg={18} md={18}  style={{ flex: 1, textAlign: "left" }}>
                  <h2 style={componentStyles.headingStyleProfile}>
                    Edit Your Personal Information
                  </h2>
                </Col>
              </Row>
                 
                <Row>
                  <Col
                    lg={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 2 }}
                    xs={{ span: 24, offset: 0 }}
                    sm={{ span: 24, offset: 0 }}
                  >
                    <Row style={componentStyles.rowStyle}>
                      <Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="name"
                          rules={[
                            { required: true, message: "Please input your username!" },
                          ]}
                          label={<span style={componentStyles.labelStyle}>Name</span>}
                        >
                          <Input
                            style={componentStyles.inputStyle}
                            disabled={false}
                            placeholder="Enter Name"
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="trustedEmail"
                          label={<span style={componentStyles.labelStyle}>Trusted Email</span>}
                        >
                          <Input
                            style={componentStyles.inputStyle}
                            disabled={false}
                            type="email"
                            placeholder="Enter Their Trusted Email"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={componentStyles.rowStyle}>
                      <Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="email"
                          rules={[
                            ...emailRules,
                            ...(process.env.REACT_APP_ENV === 'production'
                              ? [
                                  {
                                    validator: (_, value) => {
                                      if (value && /\+/.test(value)) {
                                        return Promise.reject(
                                          new Error("Email addresses with '+' are not allowed.")
                                        );
                                      }
                                      return Promise.resolve();
                                    },
                                  },
                                ]
                              : []),
                          ]}
                          label={<span style={componentStyles.labelStyle}>Email Address</span>}
                        >
                          <Input
                            style={componentStyles.inputStyle}
                            disabled={false}
                            placeholder="Enter Email Address"
                            type="email"
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="age"
                          label={<span style={componentStyles.labelStyle}>Age</span>}
                        >
                          <Select
                            style={componentStyles.selectStyle}
                            placeholder="Select Age Range"
                            disabled={false}
                          >
                            <Option value="18-24">18-24</Option>
                            <Option value="25-34">25-34</Option>
                            <Option value="35-44">35-44</Option>
                            <Option value="45-54">45-54</Option>
                            <Option value="55-64">55-64</Option>
                            <Option value="65-74">65-74</Option>
                            <Option value="75+">75+</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={componentStyles.rowStyle}>
                      <Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="phone"
                          label={<span style={componentStyles.labelStyle}>Phone Number</span>}
                        >
                          <Input
                            style={componentStyles.inputStyle}
                            disabled={false}
                            placeholder="Enter Your Phone Number"
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="password"
                          label={<span style={componentStyles.labelStyle}>Password</span>}
                        >
                          <Input
                            style={componentStyles.inputStyle}
                            disabled={true}
                            placeholder="xxxxxxx"
                            type="password"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={componentStyles.rowStyle}>
                      {address.street && (<Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="address_street"
                          label={<span style={componentStyles.labelStyle}>Address Street</span>}
                        >
                          <Input
                            style={componentStyles.inputStyle}
                            placeholder="Enter Address Street"
                          />
                        </Form.Item>
                      </Col>)}

                      {address.postal_code && (
                        <Col
                          lg={{ span: 9, offset: 0 }}
                          md={{ span: 9, offset: 0 }}
                          xs={{ span: 21, offset: 1 }}
                          sm={{ span: 21, offset: 1 }}
                        >
                          <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            name="postal_code"
                            label={<span style={componentStyles.labelStyle}>Postal Code</span>}
                          >
                            <Input
                              style={componentStyles.inputStyle}
                              placeholder="Enter Postal Code"
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    <Row style={componentStyles.rowStyle}>
                      <Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="city"
                          label={<span style={componentStyles.labelStyle}>City</span>}
                        >
                          <Input
                            style={componentStyles.inputStyle}
                            placeholder="City"
                          />
                        </Form.Item>
                      </Col>

                      <Col
                        lg={{ span: 9, offset: 0 }}
                        md={{ span: 9, offset: 0 }}
                        xs={{ span: 21, offset: 1 }}
                        sm={{ span: 21, offset: 1 }}
                      >
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          name="country"
                          label={<span style={componentStyles.labelStyle}>Country</span>}
                        >
                          <Select
                            style={componentStyles.selectStyle}
                            placeholder="Select Country"
                            showSearch
                            filterOption={(input, option) =>
                              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                           
                            options={[
                                { value: '', label: 'Select Country' }, // Always show "Select Country" as the first option
                                ...Countries.map(country => ({
                                  value: country.value,
                                  label: country.value === 'Unknown' ? 'Select Country' : country.label // Replace "Unknown" with "Select Country"
                                }))
                              ]}
                          />
                        </Form.Item>
                        <div style={{ marginTop: "8px" }}>
                          <Checkbox checked={medicalConsent} onChange={(e) => setMedicalConsent(e.target.checked)}>
                            <span style={{ fontSize: "13px", color: "#333" }}>
                              I give consent for access to my wellness journal by the admin team
                            </span>
                          </Checkbox>
                        </div>
                      </Col>

                    </Row>
                    <Row style={{ ...componentStyles.rowStyle }}>
                      <Col span={24} style={componentStyles.buttonColStyling}>
                        <Button onClick={handleBack} style={{ ...componentStyles.marginRight, ...componentStyles.cancelButtonStyle }}>Cancel</Button>
                        <Button onClick={handleSave} type="primary" style={componentStyles.saveButtonStyle}>Save</Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        )}
      </Col>
    </div>
  );
};

export default Profile;
